import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import logo from "./logo.png";
import mlogo from "./logo.png";
import styled from "styled-components";
import { motion, useAnimation } from "framer-motion";
import { Burger, Menu } from "./components";
import FocusLock from "react-focus-lock";
import { Link, animateScroll as scroll } from "react-scroll";
import theme from "styled-theming";
import { useSelector, useDispatch } from "react-redux";
import Fb from "./fb.png";
import dis from "./dis.png";
import insta from "./insta.png";
import twi from "./twi.png";

export const backgroundColor = theme("theme", {
  light: "#000000",
  dark: "#E5E5E5",
});

const Link1 = styled(Link)`
  display: flex;
  margin: 0 3rem 0 10rem;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  @-webkit-keyframes hvr-pulse {
    25% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
    75% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
  }
  @keyframes hvr-pulse {
    25% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
    75% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
  }
 
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  
  &:hover, &:focus, &:active {
    -webkit-animation-name: hvr-pulse;
    animation-name: hvr-pulse;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }
}
@media(max-width: 1500px){
   margin: 0 0 0 2rem;
}

`;

const Link2 = styled(Link)`
  display: flex;
  margin: 0 1rem;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  cursor: pointer;
  font-weight: bold;
  font-family: "Montserrat", sans-serif !important;
  @media only screen and (max-width: 768px) {
    margin: 0 1rem;
  }
`;

const H1 = styled.h1`
  color: ${backgroundColor};
`;

const Mobile = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const PC = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const Icon = styled(motion.a)`
  width: 1.5rem;
  height: 1.5rem;
  margin: 0 1rem;
  cursor: pointer;
`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const node = useRef();
  const menuId = "main-menu";

  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    // console.log(window.scrollY)
    if (window.scrollY >= 100) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  return (
    <nav className={navbar ? "navActiveLight" : "nav"}>
      <PC>
        <Link1 to="home" spy={true} smooth={true}>
          <img
            src={logo}
            alt="Logo"
            className={navbar ? "LogoActive" : "Logo"}
          />
        </Link1>
      </PC>
      <Mobile>
        <Link1 to="home" spy={true} smooth={true} style={{ marginRight: "0" }}>
          <img src={mlogo} alt="mlogo" className="LogoB" />
        </Link1>
      </Mobile>
      <PC>
        <ul className="list">
          <Link2 to="learn" spy={true} smooth={true} offset={-80}>
            Buy A kangaroo
          </Link2>
          <Link2 to="rarity" spy={true} smooth={true} offset={-80}>
            Roadmap
          </Link2>
          <Link2 to="team" spy={true} smooth={true} offset={-80}>
            Team
          </Link2>
          {/* <Link2 to="roadmap" spy={true} smooth={true} >Roadmap</Link2>  */}
          {/* <Icon
                  href='https://twitter.com/kangarooheroes' target="_blank"
                  whileHover={{scale: 1.5}}
                  whileTap={{scale:0.7}}
                  
                ><img src={Fb} alt="" style={{width:"100%",height:"100%"}} /> </Icon> */}
          <Icon
            whileHover={{ scale: 1.5 }}
            whileTap={{ scale: 0.7 }}
            href="https://twitter.com/kangarooheroes"
            target="_blank"
          >
            <img src={twi} alt="" style={{ width: "100%", height: "100%" }} />{" "}
          </Icon>
          <Icon
            whileHover={{ scale: 1.5 }}
            whileTap={{ scale: 0.7 }}
            href="https://www.instagram.com/kangarooheroes/"
            target="_blank"
          >
            <img src={insta} alt="" style={{ width: "100%", height: "100%" }} />{" "}
          </Icon>
          <Icon
            whileHover={{ scale: 1.5 }}
            whileTap={{ scale: 0.7 }}
            href="https://discord.gg/TRJawAWQNH"
            target="_blank"
          >
            <img src={dis} alt="" style={{ width: "100%", height: "100%" }} />{" "}
          </Icon>



          <Icon
            whileHover={{ scale: 1.5 }}
            whileTap={{ scale: 0.7 }}
            href="https://opensea.io/collection/kangarooheroesoriginal"
            target="_blank"
          >
            <img src={"https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"} alt="" style={{ width: "100%", height: "100%" }} />{" "}
          </Icon>


          <Icon
            whileHover={{ scale: 1.5 }}
            whileTap={{ scale: 0.7 }}
            href="https://opensea.io/collection/kangarooheroesfounders"
            target="_blank"
          >
            <img src={"https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"} alt="" style={{ width: "100%", height: "100%" }} />{" "}
          </Icon>
        </ul>
      </PC>

      <Mobile ref={node}>
        <FocusLock disabled={!open}>
          <Burger open={open} setOpen={setOpen} aria-controls={menuId} />
          <Menu open={open} setOpen={setOpen} id={menuId} />
        </FocusLock>
      </Mobile>
    </nav>
  );
};

export default Navbar;
